import Axios from 'axios'
// 刷新token
export function MotorParaSet(id) {
    return Axios
        .get('MotorMonitoringDevice/MotorParaGet', {
            params: {
                id: id
            }
        })
        .then((res) => {
            if (res.status === 200) {
                return res.data;
            } else {
                Promise.reject();
            }
        })
        .catch((err) => this.$notify.error('网络异常！'));
}